<!-- Основная строка с иконкой, текстом и toggle -->
<div class="hide-account-header"  [class.is-forbidden]="isChangeForbidden || isHardHidden">
  <app-item-icon
    icon="eye-open"
    appearance="blue"
  ></app-item-icon>

  <h2 class="hide-account-title">Скрыть счет</h2>

  <ion-toggle
    mode="ios"
    [checked]="isEnabled"
    [disabled]="isEnabled || isChangeForbidden || isHardHidden"
    (ionChange)="onToggleChange($any($event))"
    data-testid="hide-account-toggle"
  ></ion-toggle>
</div>

<!--
  <div class="hide-account-info">
    <h2 class="hide-account-title">
      {{ isHardHidden ? 'Жёсткое скрытие' : 'Скрыть счет' }}
    </h2>
    <div class="hide-account-subtitle" *ngIf="isChangeForbidden">
      Установлен запрет на изменение параметров
    </div>
    <div class="hide-account-subtitle" *ngIf="isHardHidden">
      Установлено жёсткое скрытие счёта
    </div>
    <div class="hide-account-subtitle" *ngIf="isEnabled && !isHardHidden">
      Установлено мягкое скрытие счёта
    </div>
  </div>
 -->
